import { render, staticRenderFns } from "./NewAccounting.vue?vue&type=template&id=556f4260&scoped=true"
import script from "./NewAccounting.vue?vue&type=script&lang=js"
export * from "./NewAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f4260",
  null
  
)

export default component.exports